module.exports = __webpack_public_path__ + "images/43-ic87bca48589577e0c1553d1fd2a07126.svg";